import {getContentPath} from 'system/AssetManager'
import Globals from 'system/Globals'
import axios from 'axios';


import {ReactComponent as IconMap} from 'assets/icons/_modules/expo_map.svg';
import {ReactComponent as IconGallery} from 'assets/icons/_modules/expo_gallery_images.svg'
import {ReactComponent as IconStack} from 'assets/icons/_modules/expo_stackbuilding.svg'
import {ReactComponent as Icon3D} from 'assets/icons/_modules/expo_3d.svg'
import {ReactComponent as IconDocs} from 'assets/icons/_modules/expo_documents.svg'
import {ReactComponent as IconVR2} from 'assets/icons/_modules/expo_gallery_vrs.svg'
import {ReactComponent as Presentation} from 'assets/icons/_modules/expo_presentation.svg'
import {ReactComponent as Timeline} from 'assets/icons/_modules/timeline-icon.svg'
import {ReactComponent as IconWebView} from 'assets/icons/_modules/expo_webview.svg'

// How long to wait for a module icon before giving up and drawing the bundled one.
// Any finite value beats the previous behaviour, which was to wait forever.
const ICON_FETCH_TIMEOUT_MS = 8000

// The bundled glyph for a module type. Extracted from getModuleIcon so that a FAILED
// icon fetch can fall back to exactly what an ABSENT icon already falls back to,
// rather than to nothing.
function fallbackIcon(typeName, title, s){
    let i = null
    switch(typeName){
        case 'map':
            i=<span><IconMap style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconMap><p>{title}</p></span>
        break;
        case 'mapbox':
            i=<span><IconMap style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconMap><p>{title}</p></span>
        break;
        case 'gallery':
            i=<span><IconGallery style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconGallery><p>{title}</p></span>
        break;
        case 'stack':
            i=<span><IconStack style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconStack><p>{title}</p></span>
        break;
        case 'vr':
            i=<span><IconVR2 style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconVR2><p>{title}</p></span>
        break;
        case 'webgl':
            i=<span><Icon3D style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></Icon3D><p>{title}</p></span>
        break;
        case 'document':
            i=<span><IconDocs style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconDocs><p>{title}</p></span>
        break;
        case 'timeline':
            i=<span><Timeline style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></Timeline><p>{title}</p></span>
        break;
        case 'webview-grid':
            i=<span><IconWebView style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconWebView><p>{title}</p></span>
        break;
        case 'narrative':
            i=<span><Presentation style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></Presentation><p>{title}</p></span>
        break;
        case 'controller-narrative':
            i=<span><Presentation style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></Presentation><p>{title}</p></span>
        break;
        default:
            i=<span><IconGallery style={s} className={'themeSVGStroke themeSVGStrokeHover'} key={`anarmodicon${i}`}></IconGallery><p>{title}</p></span>
        break;
    }
    return i
}

function getModuleIcon(m,theme,i){
    return new Promise(resolve=>{
    let s = Globals.instance().getThemeStyle(['nav-menu-module-icon'], theme)
    let title = m.title;
    if(m.icon){
        const ext = m.icon.split(".").pop()
        if(ext.toLowerCase()==="svg")
        {
            // This axios call had NO catch and no timeout, and every caller waits on
            // Promise.all(...).then(setIcons) (Narrative.js). So one icon that 404s,
            // times out or trips a network blip left its promise pending FOREVER --
            // Promise.all never settled, setIcons was never called, and the menu
            // rendered with NO module icons at all, not just the one that failed.
            // A kiosk on a flaky connection is exactly where that bites.
            //
            // Same defect the CMS had for one tile (#1904); here it takes the whole
            // menu. Failing to a bundled glyph is always better than failing open.
            axios.get(getContentPath(m.icon), {timeout: ICON_FETCH_TIMEOUT_MS}).then(response=>{
                resolve(<span><div style={{width:'100%',height:'100%'}} dangerouslySetInnerHTML={ {__html : response.data} }></div><p>{title}</p></span>)
            }).catch(()=>{
                resolve(fallbackIcon(m.typeName, title, s))
            })
        }else
            // A raster icon degrades on its own -- a 404 renders a broken-image
            // marker rather than hanging the promise -- so onError only hides that
            // marker and leaves the label. Every file in media/icons/ is an svg, so
            // this branch is effectively unused.
            resolve( <span><img src={getContentPath(m.icon)} alt="" className={'themeSVGStroke themeSVGStrokeHover'} onError={(e)=>{e.target.style.display='none'}}></img><p>{title}</p></span>)
    } else {
        resolve(fallbackIcon(m.typeName, title, s))
    }
    })
}


export default getModuleIcon;